webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(394);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    teamname: '',
    username: '',
    useremail: '',
    signedin: false,
    logreason: '',
    logdate: '',
    teamslackid: '',
    teamid: '',
    chartdays: null,
    charttimes: null,
    todaychart: null,
    lastactivity: ''
  },
  mutations: {
    _useremail: function _useremail(state, email) {
      state.useremail = email;
    },
    _username: function _username(state, name) {
      state.username = name;
    },
    _teamname: function _teamname(state, team) {
      state.teamname = team;
    },
    _signedin: function _signedin(state, signedin) {
      state.signedin = signedin;
    },
    _logreason: function _logreason(state, reason) {
      state.logreason = reason;
    },
    _logdate: function _logdate(state, date) {
      state.logdate = date;
    },
    _chartdays: function _chartdays(state, days) {
      state.chartdays = days;
    },
    _charttimes: function _charttimes(state, times) {
      state.charttimes = times;
    },
    _todaychart: function _todaychart(state, timein) {
      state.todaychart = timein;
    },
    _slackid: function _slackid(state, id) {
      state.teamslackid = id;
    },
    _teamid: function _teamid(state, id) {
      state.teamid = id;
    },
    _lastactivity: function _lastactivity(state, activity) {
      state.lastactivity = activity;
    }
  }
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"].extend({
  data: function data() {
    return {
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: false
            }
          }]
        },
        tooltips: {
          enabled: true,
          mode: 'single',
          callbacks: {
            label: function label(tooltipItems, data) {
              return tooltipItems.yLabel + ' Minutes';
            }
          }
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },

  mixins: [reactiveProp],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
}));

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Signin__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Signin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Signin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Activity__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Activity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Activity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Reports__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Reports___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Reports__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Settings__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Home__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SlackAuth__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SlackAuth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_SlackAuth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SlackAdd__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_SlackAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_SlackAdd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Signout__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Signout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Signout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_DashboardHome__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_DashboardHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_DashboardHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_reports_Seven__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_reports_Seven___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_reports_Seven__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_reports_Fourteen__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_reports_Fourteen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_reports_Fourteen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_reports_Thirty__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_reports_Thirty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_reports_Thirty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Admin__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_AdminSetting__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_AdminSetting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_AdminSetting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_admin_User__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_admin_User___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_admin_User__);



















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  routes: [{
    path: "/",
    name: "Home",
    component: __WEBPACK_IMPORTED_MODULE_7__components_Home___default.a
  }, {
    path: "/dashboard",
    name: "Dashboard",
    component: __WEBPACK_IMPORTED_MODULE_2__components_Dashboard___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      if (localStorage.slacktoken) {
        next();
      } else {
        next({ path: "/" });
      }
    },
    children: [{
      path: "/dashboard",
      name: "DashboardHome",
      component: __WEBPACK_IMPORTED_MODULE_11__components_DashboardHome___default.a,
      children: [{
        path: "/dashboard",
        name: "SignIn",
        component: __WEBPACK_IMPORTED_MODULE_3__components_Signin___default.a
      }, {
        path: "/signedin",
        name: "SignOut",
        component: __WEBPACK_IMPORTED_MODULE_10__components_Signout___default.a
      }]
    }, {
      path: "/reports",
      redirect: "/reports/seven",
      name: "Reports",
      component: __WEBPACK_IMPORTED_MODULE_5__components_Reports___default.a,
      children: [{
        path: "/reports/seven",
        name: "Seven",
        component: __WEBPACK_IMPORTED_MODULE_12__components_reports_Seven___default.a
      }, {
        path: "/reports/fourteen",
        name: "fourteen",
        component: __WEBPACK_IMPORTED_MODULE_13__components_reports_Fourteen___default.a
      }, {
        path: "/reports/thirty",
        name: "Thirty",
        component: __WEBPACK_IMPORTED_MODULE_14__components_reports_Thirty___default.a
      }]
    }, {
      path: "/activity",
      name: "Activity",
      component: __WEBPACK_IMPORTED_MODULE_4__components_Activity___default.a
    }, {
      path: "/settings",
      name: "Settings",
      component: __WEBPACK_IMPORTED_MODULE_6__components_Settings___default.a
    }, {
      path: "/admin",
      name: "Admin",
      component: __WEBPACK_IMPORTED_MODULE_15__components_Admin___default.a
    }, {
      path: "/admin/users/:id",
      name: "User",
      component: __WEBPACK_IMPORTED_MODULE_17__components_admin_User___default.a
    }, {
      path: "/admin/settings",
      name: "AdminSetting",
      component: __WEBPACK_IMPORTED_MODULE_16__components_AdminSetting___default.a
    }]
  }, {
    path: "/slackauth",
    name: "SlackAuth",
    component: __WEBPACK_IMPORTED_MODULE_8__components_SlackAuth___default.a
  }, {
    path: "/slackadd",
    name: "SlackAdd",
    component: __WEBPACK_IMPORTED_MODULE_9__components_SlackAdd___default.a
  }, {
    path: "*",
    redirect: "/"
  }]
}));

/***/ }),
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(328)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(392),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mini_toastr__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mini_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mini_toastr__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  mounted: function mounted() {
    this.$Progress.finish();
    __WEBPACK_IMPORTED_MODULE_0_mini_toastr___default.a.init();
  },
  created: function created() {
    var _this = this;

    this.$Progress.start();

    this.$router.beforeEach(function (to, from, next) {
      if (to.meta.progress !== undefined) {
        var meta = to.meta.progress;

        _this.$Progress.parseMeta(meta);
      }

      _this.$Progress.start();

      next();
    });

    this.$router.afterEach(function (to, from) {
      _this.$Progress.finish();
    });
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Activity',
  data: function data() {
    return {
      activities: {},
      activity: false
    };
  },

  head: {
    title: {
      inner: 'Activity',
      separator: '-',
      complement: 'Worklogs'
    }
  },
  filters: {
    capitalize: function capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.kuzcoapp.com/api/v1/log?perPage=100').then(function (response) {
      var _activities = response.data.data.records;
      next(function (vm) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_activities).length == 0) {
          vm.activity = false;
        } else {
          vm.activity = true;
        }
        var newActivities = {};

        for (var i in _activities) {

          var one = _activities[i];
          var two = _activities[i];
          if (_activities[i].length == 1) {
            var signintime = one[0].created_at;
            var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(signintime);
            var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format();

            var duration = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(start.diff(end));
            var _reason = one[0].log_description;
            var _date = signintime;

            var _momentdate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_date).format('MMMM Do YYYY, h:mm:ss a');

            newActivities[i] = {
              duration: 'Still signed in',

              date: _momentdate,
              reason: _reason
            };
            vm.activities = newActivities;
          } else if (_activities[i].length == 2) {
            var _signintime = one[0].created_at;
            var signouttime = two[1].created_at;

            var _start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_signintime);
            var _end = __WEBPACK_IMPORTED_MODULE_2_moment___default()(signouttime);

            var _duration = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(_start.diff(_end));

            var reasonone = one[0].log_description;
            var reasontwo = two[1].log_description;
            var _reason2 = reasontwo ? reasontwo : reasonone ? reasonone : '';

            var _date2 = signouttime;
            var _momentdate2 = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_date2).format('MMMM Do YYYY, h:mm:ss a');

            newActivities[i] = {
              duration: _duration.humanize(),
              date: _momentdate2,
              reason: _reason2
            };
            vm.activities = newActivities;
          } else {}
        }
      });
    }).catch(function (error) {
      next(false);
      console.log(error);
    });
  },

  watch: {
    $route: function $route() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.kuzcoapp.com/api/v1/log?perPage=100').then(function (response) {
        var _activities = response.data.data.records;
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_activities).length == 0) {
          self.activity = false;
        } else {
          self.activity = true;
        }
        var newActivities = {};
        for (var i in _activities) {
          var one = _activities[i];
          var two = _activities[i];
          if (_activities[i].length == 1) {
            var signintime = one[0].created_at;
            var start = __WEBPACK_IMPORTED_MODULE_2_moment___default()(signintime);
            var end = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format();

            var duration = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(start.diff(end));
            var _reason = one[0].log_description;
            var _date = signintime;

            var _momentdate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_date).format('MMMM Do YYYY, h:mm:ss a');

            newActivities[i] = {
              duration: 'Still signed in',

              date: _momentdate,
              reason: _reason
            };
            self.activities = newActivities;
          } else if (_activities[i].length == 2) {
            var _signintime2 = one[0].created_at;
            var signouttime = two[1].created_at;

            var _start2 = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_signintime2);
            var _end2 = __WEBPACK_IMPORTED_MODULE_2_moment___default()(signouttime);

            var _duration2 = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(_start2.diff(_end2));

            var reasonone = one[0].log_description;
            var reasontwo = two[1].log_description;
            var _reason3 = reasontwo ? reasontwo : reasonone ? reasonone : '';

            var _date3 = signouttime;

            newActivities[i] = {
              duration: _duration2.humanize(),
              date: _date3,
              reason: _reason3
            };
            self.activities = newActivities;
          } else {}
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Admin',
  data: function data() {
    return {
      id: null,
      users: null,
      loading: false,
      sloading: false,
      disabled: false,
      messagetype: null
    };
  },

  head: {
    title: {
      inner: 'Admin Reports',
      separator: '-',
      complement: 'Worklogs'
    }
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var self = this;
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.kuzcoapp.com/api/v1/team').then(function (response) {
        self.$Progress.finish();
        var _team = response.data.data.name;
        var _id = response.data.data.id;
        var _slackid = response.data.data.slack_id;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.kuzcoapp.com/api/v1/admin/users/' + _slackid).then(function (response) {
          self.loading = false;
          var _users = response.data.data;
          var _usersobj = {};
          for (var i in _users) {
            var _date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_users[i].created_at).format('MMMM Do YYYY, h:mm:ss a');
            self.id = _users[i].id;
            _usersobj[i] = {
              name: _users[i].name,
              email: _users[i].email,
              date: _date,
              id: _users[i].id
            };
          }
          self.users = _usersobj;
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function (error) {
        console.log(error);
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.kuzcoapp.com/api/admin/message_style').then(function (response) {
        _this.messagetype = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },

    submit: function submit() {
      var _this2 = this;

      this.sloading = true;
      this.disabled = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://api.kuzcoapp.com/api/admin/message_style', {
        style: this.messagetype
      }).then(function (response) {
        _this2.sloading = false;
        _this2.disabled = false;
      }).catch(function (error) {
        _this2.sloading = false;
        _this2.disabled = false;
        console.log(error);
      });
    }
  },
  computed: {
    teamid: function teamid() {
      return __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].state.teamid;
      this.slackteamid = this.$store.state.teamid;
    },
    teamslackid: function teamslackid() {
      return __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].state.teamslackid;
      this.slackid = this.$store.state.teamslackid;
    }
  }
});

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdminSetting',
  data: function data() {
    return {
      id: null,
      users: null,
      loading: false,
      sloading: false,
      disabled: false,
      messagetype: null
    };
  },

  head: {
    title: {
      inner: 'Admin Settings',
      separator: '-',
      complement: 'Worklogs'
    }
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var self = this;
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.kuzcoapp.com/api/v1/team').then(function (response) {
        self.$Progress.finish();
        var _team = response.data.data.name;
        var _id = response.data.data.id;
        var _slackid = response.data.data.slack_id;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.kuzcoapp.com/api/v1/admin/users/' + _slackid).then(function (response) {
          self.loading = false;
          var _users = response.data.data;
          var _usersobj = {};
          for (var i in _users) {
            var _date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_users[i].created_at).format('MMMM Do YYYY, h:mm:ss a');
            self.id = _users[i].id;
            _usersobj[i] = {
              name: _users[i].name,
              email: _users[i].email,
              date: _date,
              id: _users[i].id
            };
          }
          self.users = _usersobj;
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function (error) {
        console.log(error);
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.kuzcoapp.com/api/admin/message_style').then(function (response) {
        _this.messagetype = response.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },

    submit: function submit() {
      var _this2 = this;

      this.sloading = true;
      this.disabled = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://api.kuzcoapp.com/api/admin/message_style', {
        style: this.messagetype
      }).then(function (response) {
        _this2.sloading = false;
        _this2.disabled = false;
      }).catch(function (error) {
        _this2.sloading = false;
        _this2.disabled = false;
        console.log(error);
      });
    }
  },
  computed: {
    teamid: function teamid() {
      return __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].state.teamid;
      this.slackteamid = this.$store.state.teamid;
    },
    teamslackid: function teamslackid() {
      return __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].state.teamslackid;
      this.slackid = this.$store.state.teamslackid;
    }
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(5);




__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.slacktoken;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dashboard',
  data: function data() {
    return {
      slackteamid: null,
      slackid: null,
      isAdmin: false,
      isActive: false
    };
  },

  head: {
    title: {
      inner: 'Dashboard',
      separator: '-',
      complement: 'Worklogs'
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var self = this;
      this.$Progress.start();
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.kuzcoapp.com/api/v1/me?token=' + localStorage.slacktoken).then(function (response) {
        self.$Progress.finish();
        var _username = response.data.user.name;
        var _email = response.data.user.email;
        var _team = response.data.user.team.name;
        var _id = response.data.user.team.id;
        var _slackid = response.data.user.team.slack_id;
        __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('_username', _username);
        __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('_useremail', _email);
        __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('_teamid', _id);
        __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('_teamname', _team);
        __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('_slackid', _slackid);
        if (localStorage.admin) {
          self.isAdmin = true;
        } else if (!localStorage.admin) {
          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.kuzcoapp.com/api/v1/admin/users/' + _slackid).then(function (response) {
            if (response.data.status == "success") {
              localStorage.admin = true;
              self.isAdmin = true;
            } else {
              localStorage.admin = false;
              self.isAdmin = false;
            }
          }).catch(function (error) {
            console.log(error);
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    signOut: function signOut() {
      var self = this;
      if (localStorage.kloggedin == 'true') {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://api.kuzcoapp.com/api/v1/log', {
          log_type: 2,
          log_description: 'Signed out of Worklogs'
        }).then(function (response) {}).catch(function (response) {
          console.log(error);
        });
      }
      localStorage.clear();
      var _kuzcoin = false;
      this.$router.push('/');
    },
    showMenu: function showMenu() {
      this.isActive = !this.isActive;
    }
  },
  computed: {
    username: function username() {
      return __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].state.username;
      this.username = this.$store.state.username;
    },
    email: function email() {
      return __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].state.useremail;
      this.email = this.$store.state.useremail;
    },
    team: function team() {
      return __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].state.teamname;
      this.teamname = this.$store.state.teamname;
    },
    teamid: function teamid() {
      return __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].state.teamid;
      this.slackteamid = this.$store.state.teamid;
    },
    teamslackid: function teamslackid() {
      return __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].state.teamslackid;
      this.slackid = this.$store.state.teamslackid;
    }
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_timezone__);








__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.slacktoken;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Signin',
  data: function data() {
    return {
      computedActivities: {},
      isSignedin: false,
      activity: false,
      loggedReason: '',
      loggedOutReason: '',
      signInTime: '',
      test: 'this is a test'
    };
  },

  filters: {
    capitalize: function capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://api.kuzcoapp.com/api/v1/log').then(function (response) {
      var _activities = response.data.data.records;
      next(function (vm) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_activities).length == 0) {
          vm.activity = false;
        } else {
          vm.activity = true;
        }
        vm.mainActivities = _activities;
        var newActivities = {};
        for (var i in _activities) {
          if (i > 3) break;
          var one = _activities[i];
          var two = _activities[i];
          if (_activities[i].length == 1) {
            var signintime = one[0].created_at;
            var start = __WEBPACK_IMPORTED_MODULE_3_moment___default()(signintime);
            var end = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format();
            var duration = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(start.diff(end));
            var _reason = one[0].log_description;
            var _date2 = signintime;
            var _momentdate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(_date2).format('MMMM Do YYYY, h:mm:ss a');
            newActivities[i] = {
              duration: 'Still signed in',
              date: _momentdate,
              reason: _reason
            };
            vm.computedActivities = newActivities;
            __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('_lastactivity', newActivities);
          } else if (_activities[i].length == 2) {
            var _signintime = one[0].created_at;
            var signouttime = two[1].created_at;
            var _start = __WEBPACK_IMPORTED_MODULE_3_moment___default()(_signintime);
            var _end = __WEBPACK_IMPORTED_MODULE_3_moment___default()(signouttime);
            var _duration = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(_start.diff(_end));
            var reasonone = one[0].log_description;
            var reasontwo = two[1].log_description;
            var _reason2 = reasontwo ? reasontwo : reasonone ? reasonone : '';
            var _date3 = signouttime;
            var _momentdate2 = __WEBPACK_IMPORTED_MODULE_3_moment___default()(_date3).format('MMMM Do YYYY, h:mm:ss a');
            newActivities[i] = {
              duration: _duration.humanize(),
              date: _momentdate2,
              reason: _reason2
            };
            vm.computedActivities = newActivities;
            __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('_lastactivity', newActivities);
          } else {}
        }
      });
    }).catch(function (error) {
      next(false);
      console.log(error);
    });
  },

  watch: {
    $route: function $route() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://api.kuzcoapp.com/api/v1/log').then(function (response) {
        var _activities = response.data.data.records;
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_activities).length == 0) {
          self.activity = false;
        } else {
          self.activity = true;
        }
        var newActivities = {};
        for (var i in _activities) {
          if (i > 3) break;
          var one = _activities[i];
          var two = _activities[i];
          if (_activities[i].length == 1) {
            var signintime = one[0].created_at;
            var start = __WEBPACK_IMPORTED_MODULE_3_moment___default()(signintime);
            var end = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format();
            var duration = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(start.diff(end));
            var _reason = one[0].log_description;
            var _momentdate = __WEBPACK_IMPORTED_MODULE_3_moment___default()(_date).format('MMMM Do YYYY, h:mm:ss a');
            newActivities[i] = {
              duration: 'Still signed in',
              date: _momentdate,
              reason: _reason
            };
            self.computedActivities = newActivities;
            __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('_lastactivity', newActivities);
          } else if (_activities[i].length == 2) {
            var _signintime2 = one[0].created_at;
            var signouttime = two[1].created_at;
            var _start2 = __WEBPACK_IMPORTED_MODULE_3_moment___default()(_signintime2);
            var _end2 = __WEBPACK_IMPORTED_MODULE_3_moment___default()(signouttime);
            var _duration2 = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(_start2.diff(_end2));
            var reasonone = one[0].log_description;
            var reasontwo = two[1].log_description;
            var _reason3 = reasontwo ? reasontwo : reasonone ? reasonone : '';
            var _date4 = signouttime;
            newActivities[i] = {
              duration: _duration2.humanize(),
              date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(_date4).format('MMMM Do YYYY, h:mm:ss a'),
              reason: _reason3
            };
            self.computedActivities = newActivities;
            __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('_lastactivity', newActivities);
          }
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  computed: {
    signedin: function signedin() {
      return __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].state.signedin;
    },
    lastactivity: function lastactivity() {
      return __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].state.lastactivity;
    }
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Home',
  data: function data() {
    return {
      kuzcosignedin: false
    };
  },

  watch: {
    '$route': 'fetchData'
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var self = this;
      if (localStorage.firstload == 'true') {
        localStorage.firstload = false;
        window.location.reload();
      } else {}

      if (localStorage.globalsignin) {
        self.kuzcosignedin = true;
      } else {
        self.kuzcosignedin = false;
      }
    },
    signOut: function signOut() {
      localStorage.clear();
      window.location.reload();
    }
  }

});

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ReportsCharts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TodayChart__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(5);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Reports',
  components: { ReportsCharts: __WEBPACK_IMPORTED_MODULE_0__components_ReportsCharts__["a" /* default */], TodayChart: __WEBPACK_IMPORTED_MODULE_1__components_TodayChart__["a" /* default */] },
  data: function data() {
    return {
      todaytime: '',
      drr: '',
      summaryreports: null
    };
  },

  head: {
    title: {
      inner: 'Reports',
      separator: '-',
      complement: 'Worklogs'
    }
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    var _begintoday = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("Y-MM-D") + " 00:00:00";
    var _endtoday = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("Y-MM-D") + " 23:59:59";
    var today = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("Y-MM-D") + " 23:59:59";

    function secondsToHumanize(time) {
      time = time + '000';
      time = Number(time);
      time = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(time).humanize();
      return time;
    }

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://api.kuzcoapp.com/api/v1/report?start=' + _begintoday + '&end=' + _endtoday).then(function (response) {
      var _totaltime = response.data.data.total_time;

      var _today = Math.round(_totaltime / (24 * 60 * 60) * 100);
      var _notsignedin = Math.round(100 - _today);
      var _chartdata = [_today, _notsignedin];

      next(function (vm) {
        vm.todaytime = secondsToHumanize(_totaltime);
        __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].commit('_todaychart', _chartdata);
      });
    }).catch(function (error) {
      next(false);
      console.log(error);
    });
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://api.kuzcoapp.com/api/v1/report?start=2017-01-01&end=2020-01-01').then(function (response) {
      var _reports = response.data.data.reports;
      var _rep = {};
      for (var i in _reports) {
        var _time = _reports[i].time;
        var _date = _reports[i].date;
        _time = secondsToHumanize(_time);
        _date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(_date).format('MMMM Do YYYY');
        _rep[i] = {
          date: _date,
          time: _time
        };
      }
      next(function (vm) {
        vm.summaryreports = _rep;
      });
    }).catch(function (error) {
      console.log(error);
    });
  },

  watch: {
    $route: function $route() {
      var _begintoday = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("Y-MM-D") + " 00:00:00";
      var _endtoday = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("Y-MM-D") + " 23:59:59";
      var today = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("Y-MM-D") + " 23:59:59";
      var self = this;
      function secondsToHumanize(time) {
        time = time + '000';
        time = Number(time);
        time = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(time).humanize();
        return time;
      }
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://api.kuzcoapp.com/api/v1/report?start=' + _begintoday + '&end=' + _endtoday).then(function (response) {
        var _totaltime = response.data.data.total_time;

        var _today = Math.round(_totaltime / (24 * 60 * 60) * 100);
        var _notsignedin = Math.round(100 - _today);
        var _chartdata = [_today, _notsignedin];

        self.todaytime = secondsToHumanize(_totaltime);
        __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].commit('_todaychart', _chartdata);
      }).catch(function (error) {
        console.log(error);
      });
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://api.kuzcoapp.com/api/v1/report?start=2017-01-01&end=2020-01-01').then(function (response) {
        var _reports = response.data.data.reports;
        var _rep = {};
        for (var i in _reports) {
          var _time = _reports[i].time;
          var _date = _reports[i].date;
          _time = secondsToHumanize(_time);
          _date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(_date).format('MMMM Do YYYY');
          _rep[i] = {
            date: _date,
            time: _time
          };
        }
        self.summaryreports = _rep;
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  computed: {
    datasetsfull: function datasetsfull() {
      return {
        labels: ['Signed In(%)', 'Not Signed In(%)'],
        datasets: [{
          label: 'Hours Logged In',
          backgroundColor: ['#40cf97', '#3D484F'],
          data: __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.todaychart
        }]
      };
    },
    todaychart: function todaychart() {
      return __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.todaychart;
    }
  }
});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_select__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Settings',
  data: function data() {
    return {
      tagged: null,
      timezone: null,
      loading: false,
      disabled: false,
      teamid: null,
      slackid: null
    };
  },

  head: {
    title: {
      inner: 'Settings',
      separator: '-',
      complement: 'Worklogs'
    }
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.kuzcoapp.com/api/v1/team').then(function (response) {
        var _id = response.data.data.id;
        var _slackid = response.data.data.slack_id;
        _this.teamid = _id;
        _this.slackid = _slackid;
        __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].commit('_teamid', _id);
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.kuzcoapp.com/api/v1/team/' + _id + '/tagged').then(function (response) {
          _this.tagged = response.data.data.persons_tagged;
        }).catch(function (error) {
          console.log(error);
        });
      }).catch(function (error) {
        console.log(error);
      });
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.kuzcoapp.com/api/v1/me/timezone').then(function (response) {
        var _timezone = response.data.data;
        _this.timezone = _timezone;
      }).catch(function (error) {
        console.log(error);
      });
    },
    submit: function submit() {
      var _this2 = this;

      this.loading = true;
      this.disabled = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://api.kuzcoapp.com/api/v1/team/' + __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.teamid + '/tagged', {
        persons: this.tagged
      }).then(function (response) {
        _this2.loading = false;
        _this2.disabled = false;
      }).catch(function (error) {
        _this2.loading = false;
        _this2.disabled = false;
        console.log(error);
      });
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://api.kuzcoapp.com/api/v1/me/timezone', {
        timezone: this.timezone
      }).then(function (response) {
        _this2.loading = false;
        _this2.disabled = false;
      }).catch(function (error) {
        _this2.loading = false;
        _this2.disabled = false;
        console.log(error);
      });
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://api.kuzcoapp.com/api/admin/message_style', {
        style: this.messagetype
      }).then(function (response) {
        _this2.loading = false;
        _this2.disabled = false;
      }).catch(function (error) {
        _this2.loading = false;
        _this2.disabled = false;
        console.log(error);
      });
    }
  },
  computed: {
    username: function username() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.username;
      this.username = this.$store.state.username;
    },
    email: function email() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.useremail;
      this.email = this.$store.state.useremail;
    },
    team: function team() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.teamname;
      this.teamname = this.$store.state.teamname;
    },
    teamid: function teamid() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.teamid;
      this.teamid = this.$store.state.teamid;
    }
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_select__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Signin',
  components: { vSelect: __WEBPACK_IMPORTED_MODULE_3_vue_select___default.a },
  data: function data() {
    return {
      formReason: null,
      existing: false,
      typedreason: true,
      loading: false,
      existingReasons: null,
      disabled: false
    };
  },

  notifications: {
    signInError: {
      title: 'Signed in already',
      message: 'You are already signed in.',
      type: 'error' }
  },
  watch: {
    '$route': 'fetchData'
  },
  created: function created() {
    this.fetchData();
  },
  computed: {
    username: function username() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.username;
    },
    logreason: function logreason() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.logreason;
    },
    logdate: function logdate() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.logdate;
    },
    lastactivity: function lastactivity() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.lastactivity;
    }
  },
  methods: {
    fetchData: function fetchData() {
      var self = this;
      if (localStorage.kloggedin == 'true') {
        self.$router.push('/signedin');
      } else {}
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.kuzcoapp.com/api/v1/me/reasons').then(function (response) {
        var reasonsArr = [];
        var _reasons = response.data.data;
        for (var i in _reasons) {
          reasonsArr.push(_reasons[i]);
        }
        self.existingReasons = reasonsArr;
      });
    },
    existingReason: function existingReason() {
      var self = this;
      self.existing = true;
      self.typedreason = false;
    },
    typedReason: function typedReason() {
      var self = this;
      self.existing = false;
      self.typedreason = true;
    },
    signInToSlack: function signInToSlack() {
      var self = this;
      self.loading = true;
      self.disabled = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://api.kuzcoapp.com/api/v1/log', {
        log_type: 1,
        log_description: self.formReason
      }).then(function (response) {
        self.formReason = null;
        self.loading = false;
        self.disabled = false;

        var _time = response.data.data.updated_at;

        var _momenttime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(_time).format('MMMM Do YYYY, h:mm:ss a');
        var _reason = response.data.data.log_description;
        var _signedin = true;
        var emptyreason = '';
        if (_reason) {
          __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].commit('_logreason', _reason);
          localStorage.logreason = _reason;
        } else {
          __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].commit('_logreason', emptyreason);
          localStorage.logreason = emptyreason;
        }
        __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].commit('_logdate', _momenttime);
        __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].commit('_signedin', _signedin);
        localStorage.logdate = _momenttime;
        localStorage.kloggedin = true;

        self.$router.push('/signedin');
      }).catch(function (error) {
        if (error.response.data.code == '411') {
          self.signInError({ message: error.response.data.message });
          var _lastactivity = __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.lastactivity;

          for (var i in _lastactivity) {
            if (i > 1) break;
            localStorage.logreason = _lastactivity[i].reason;
            localStorage.logdate = _lastactivity[i].date;
            localStorage.kloggedin = true;
          }
        }
        self.loading = false;
        self.disabled = false;
      });
    }
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_select__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Signout',
  components: { vSelect: __WEBPACK_IMPORTED_MODULE_3_vue_select___default.a },
  data: function data() {
    return {
      loading: false,
      disabled: false,
      loggedOutReason: '',
      existingReasons: null,
      existing: false,
      typedreason: true,
      klogdate: null,
      klogreason: null
    };
  },

  notifications: {
    signInError: {
      title: 'Signed out already',
      message: 'You are already signed out.',
      type: 'error' }
  },
  watch: {
    '$route': 'fetchData'
  },
  created: function created() {
    this.fetchData();
  },
  computed: {
    logreason: function logreason() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.logreason;
    },
    logdate: function logdate() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.logdate;
    },
    signedin: function signedin() {
      return __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].state.signedin;
    }
  },
  methods: {
    fetchData: function fetchData() {
      var self = this;
      self.klogdate = localStorage.logdate;
      self.klogreason = localStorage.logreason;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.kuzcoapp.com/api/v1/me/reasons').then(function (response) {
        var reasonsArr = [];
        var _reasons = response.data.data;
        for (var i in _reasons) {
          reasonsArr.push(_reasons[i]);
        }
        self.existingReasons = reasonsArr;
      });
    },
    existingReason: function existingReason() {
      var self = this;
      self.existing = true;
      self.typedreason = false;
    },
    typedReason: function typedReason() {
      var self = this;
      self.existing = false;
      self.typedreason = true;
    },
    signOutSlack: function signOutSlack() {
      var self = this;
      self.loading = true;
      self.disabled = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://api.kuzcoapp.com/api/v1/log', {
        log_type: 2,
        log_description: self.loggedOutReason
      }).then(function (response) {
        self.loading = false;
        self.disabled = false;

        var _signedin = false;
        var _time = null;
        var _reason = null;

        __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].commit('_signedin', _signedin);
        __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].commit('_logreason', _reason);
        __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].commit('_logdate', _time);

        localStorage.logreason = _reason;
        localStorage.logdate = _time;
        localStorage.kloggedin = false;

        self.$router.push('dashboard');
      }).catch(function (error) {
        if (error.response.data.code == '411') {
          self.signInError({ message: error.response.data.message });
          var _signedin = false;
          var _time = null;
          var _reason = null;

          __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].commit('_signedin', _signedin);
          __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].commit('_logreason', _reason);
          __WEBPACK_IMPORTED_MODULE_0__store_store__["a" /* store */].commit('_logdate', _time);

          localStorage.logreason = _reason;
          localStorage.logdate = _time;
          localStorage.kloggedin = false;

          self.$router.push('dashboard');
        }
        self.loading = false;
        self.disabled = false;
      });
    }
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(42);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SlackAuth',
  data: function data() {
    return {
      username: '',
      useremail: '',
      team: '',
      added: false
    };
  },
  mounted: function mounted() {
    var self = this;
    var getQueryString = function getQueryString(field, url) {
      var href = url ? url : window.location.href;
      var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
      var string = reg.exec(href);
      return string ? string[1] : null;
    };

    var _code = getQueryString('code');
    var _state = getQueryString('state');

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.kuzcoapp.com/slack/team/redirect?code=' + _code + '&state=' + _state).then(function (response) {
      var _status = true;
      self.added = true;
    }).catch(function (error) {
      console.log(error);
    });
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(42);






__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.slacktoken;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SlackAuth',
  data: function data() {
    return {
      username: '',
      useremail: '',
      team: ''
    };
  },

  notifications: {
    showLoginError: {
      title: 'Login Failed',
      message: 'We couldn\'t sign you in.',
      type: 'error' }
  },
  created: function created() {
    var self = this;
    var getQueryString = function getQueryString(field, url) {
      var href = url ? url : window.location.href;
      var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
      var string = reg.exec(href);
      return string ? string[1] : null;
    };

    var _code = getQueryString('code');
    var _state = getQueryString('state');

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.kuzcoapp.com/slack/redirect?code=' + _code + '&state=' + _state).then(function (response) {
      localStorage.globalsignin = true;
      localStorage.slacktoken = response.data.data.token;
      localStorage.firstload = true;

      var _username = response.data.data.user.name;
      var _email = response.data.data.user.email;
      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('_username', _username);
      __WEBPACK_IMPORTED_MODULE_1__store_store__["a" /* store */].commit('_useremail', _email);
      self.$router.replace('/');
    }).catch(function (error) {
      self.showLoginError();
      self.$router.push('/');
    });
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(5);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'User',
  data: function data() {
    return {
      totaltime: null,
      reports: null,
      loading: false,
      name: null
    };
  },
  created: function created() {
    this.fetchData();
  },

  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData: function fetchData() {
      this.loading = true;
      var self = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.kuzcoapp.com/api/v1/team').then(function (response) {
        var _team = response.data.data.name;
        var _id = response.data.data.id;
        var _slackid = response.data.data.slack_id;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://api.kuzcoapp.com/api/v1/admin/reports/' + _slackid + '?user_id=' + self.$route.params.id + '&start=2017-01-01&end=2020-01-01').then(function (response) {
          self.loading = false;
          var _totaltime = response.data.data[0].results.total_time;
          var _reports = response.data.data[0].results.reports;
          self.name = response.data.data[0].user.name;
          function secondsToHumanize(time) {
            time = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(time, "seconds").humanize();
            return time;
          }
          self.totaltime = secondsToHumanize(_totaltime);
          var _rep = {};
          for (var i in _reports) {
            var _time = _reports[i].time;
            var _date = _reports[i].date;
            _time = secondsToHumanize(_time);
            _date = __WEBPACK_IMPORTED_MODULE_1_moment___default()(_date).format('MMMM Do YYYY');
            _rep[i] = {
              date: _date,
              time: _time
            };
          }
          self.reports = _rep;
        }).catch(function (error) {});
      }).catch(function (error) {});
    }
  },
  computed: {
    teamid: function teamid() {
      return __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* store */].state.teamid;
      this.slackteamid = this.$store.state.teamid;
    },
    teamslackid: function teamslackid() {
      return __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* store */].state.teamslackid;
      this.slackid = this.$store.state.teamslackid;
    }
  }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ReportsCharts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_underscore__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Fourteen',
  components: { ReportsCharts: __WEBPACK_IMPORTED_MODULE_0__components_ReportsCharts__["a" /* default */] },
  data: function data() {
    return {
      fourteentime: ''
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    function getFourteen() {
      var _fourteendays = 14;
      var _date = new Date();
      var _last = new Date(_date.getTime() - _fourteendays * 24 * 60 * 60 * 1000);
      var _day = _last.getDate();
      _day = (_day < 10 ? "0" : "") + _day;
      var _month = _last.getMonth() + 1;
      _month = (_month < 10 ? "0" : "") + _month;
      var _year = _last.getFullYear();

      var _thadate = _year + '-' + _month + '-' + _day;
      return _thadate + " 00:00:00";
    }
    var fourteendays = getFourteen();
    var today = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format("Y-MM-D") + " 23:59:59";
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.kuzcoapp.com/api/v1/report?start=' + fourteendays + '&end=' + today).then(function (response) {
      var _totaltime = response.data.data.total_time;
      var _reports = response.data.data.reports;
      var momentFourteen = function momentFourteen() {
        var arr = [];

        var _today = {
          date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
          time: "0"
        };
        arr.push(_today);

        for (var i = 1; i < 14; i += 1) {
          var ym = __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(i, 'days').format('YYYY-MM-DD');
          var rm = __WEBPACK_IMPORTED_MODULE_2_moment___default()(ym).format('MMMM Do');
          var dm = {
            date: ym,
            time: "0"
          };
          arr.push(dm);
        }
        return arr;
      };
      var _fourteen = momentFourteen();
      function mergeByProperty(_fourteen, _reports, prop) {
        __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.each(_reports, function (arr2obj) {
          var arr1obj = __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.find(_fourteen, function (arr1obj) {
            return arr1obj[prop] === arr2obj[prop];
          });

          arr1obj ? __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.extend(arr1obj, arr2obj) : _fourteen.push(arr2obj);
        });
      }
      mergeByProperty(_fourteen, _reports, 'date');

      var timeresult = _fourteen.map(function (a) {
        a.time = a.time + "000";
        a.time = Number(a.time);
        a.time = Math.round(__WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(a.time).asMinutes());
        return a.time;
      });
      var dateresult = _fourteen.map(function (a) {
        a.date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.date).format('MMMM Do');
        return a.date;
      });
      function secondsToHumanize(time) {
        time = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(time, "seconds").humanize();
        return time;
      }
      next(function (vm) {
        vm.cdays = dateresult.reverse();
        vm.ctimes = timeresult.reverse();
        __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].commit('_charttimes', timeresult);
        __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].commit('_chartdays', dateresult);
        vm.fourteentime = secondsToHumanize(_totaltime);
      });
    }).catch(function (error) {
      next(false);
    });
  },

  watch: {
    $route: function $route() {
      function getFourteen() {
        var _fourteendays = 14;
        var _date = new Date();
        var _last = new Date(_date.getTime() - _fourteendays * 24 * 60 * 60 * 1000);
        var _day = _last.getDate();
        _day = (_day < 10 ? "0" : "") + _day;
        var _month = _last.getMonth() + 1;
        _month = (_month < 10 ? "0" : "") + _month;
        var _year = _last.getFullYear();

        var _thadate = _year + '-' + _month + '-' + _day;
        return _thadate + " 00:00:00";
      }
      var fourteendays = getFourteen();
      var today = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format("Y-MM-D") + " 23:59:59";
      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.kuzcoapp.com/api/v1/report?start=' + fourteendays + '&end=' + today).then(function (response) {
        var _totaltime = response.data.data.total_time;
        var _reports = response.data.data.reports;
        var momentFourteen = function momentFourteen() {
          var arr = [];
          var _today = {
            date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
            time: "0"
          };
          arr.push(_today);
          for (var i = 1; i < 14; i += 1) {
            var ym = __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(i, 'days').format('YYYY-MM-DD');
            var rm = __WEBPACK_IMPORTED_MODULE_2_moment___default()(ym).format('MMMM Do');
            var dm = {
              date: ym,
              time: "0"
            };
            arr.push(dm);
          }
          return arr;
        };
        var _fourteen = momentFourteen();

        function mergeByProperty(_fourteen, _reports, prop) {
          __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.each(_reports, function (arr2obj) {
            var arr1obj = __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.find(_fourteen, function (arr1obj) {
              return arr1obj[prop] === arr2obj[prop];
            });

            arr1obj ? __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.extend(arr1obj, arr2obj) : _fourteen.push(arr2obj);
          });
        }
        mergeByProperty(_fourteen, _reports, 'date');

        var timeresult = _fourteen.map(function (a) {
          a.time = a.time + "000";
          a.time = Number(a.time);
          a.time = Math.round(__WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(a.time).asMinutes());
          return a.time;
        });
        var dateresult = _fourteen.map(function (a) {
          a.date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.date).format('MMMM Do');
          return a.date;
        });

        self.cdays = dateresult.reverse();
        self.ctimes = timeresult.reverse();
        __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].commit('_charttimes', timeresult);
        __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].commit('_chartdays', dateresult);
        function secondsToHumanize(time) {
          time = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(time, "seconds").humanize();
          return time;
        }
        self.fourteentime = secondsToHumanize(_totaltime);
      }).catch(function (error) {});
    }
  },
  computed: {
    datasetsfull: function datasetsfull() {
      return {
        labels: __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.chartdays,
        datasets: [{
          label: 'Time(Hours)',
          backgroundColor: '#40CF97',
          data: __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.charttimes
        }]
      };
    },
    chartdays: function chartdays() {
      return __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.chartdays;
    },
    charttimes: function charttimes() {
      return __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.charttimes;
    }
  }
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ReportsCharts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_underscore__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Seven',
  components: { ReportsCharts: __WEBPACK_IMPORTED_MODULE_0__components_ReportsCharts__["a" /* default */] },
  data: function data() {
    return {
      seventime: ''
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    function getSeven() {
      var _sevendays = 7;
      var _date = new Date();
      var _last = new Date(_date.getTime() - _sevendays * 24 * 60 * 60 * 1000);
      var _day = _last.getDate();
      _day = (_day < 10 ? "0" : "") + _day;
      var _month = _last.getMonth() + 1;
      _month = (_month < 10 ? "0" : "") + _month;
      var _year = _last.getFullYear();

      var _thadate = _year + '-' + _month + '-' + _day;
      return _thadate + " 00:00:00";
    }
    function secondsToHumanize(time) {
      time = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(time, "seconds").humanize();
      return time;
    }
    function secondsToHours(time) {
      time = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(time).asHours();
      return time;
    }

    var sevendays = getSeven();
    var today = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("Y-MM-D") + " 23:59:59";

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.kuzcoapp.com/api/v1/report?start=' + sevendays + '&end=' + today).then(function (response) {
      var _totaltime = response.data.data.total_time;
      var _reports = response.data.data.reports;

      var momentSeven = function momentSeven() {
        var arr = [];
        var _today = {
          date: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),
          time: "0"
        };
        arr.push(_today);
        for (var i = 1; i < 7; i += 1) {
          var ym = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(i, 'days').format('YYYY-MM-DD');
          var rm = __WEBPACK_IMPORTED_MODULE_3_moment___default()(ym).format('MMMM Do');
          var dm = {
            date: ym,
            time: "0"
          };
          arr.push(dm);
        }
        return arr;
      };
      var _seven = momentSeven();

      function mergeByProperty(_seven, _reports, prop) {
        __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.each(_reports, function (arr2obj) {
          var arr1obj = __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.find(_seven, function (arr1obj) {
            return arr1obj[prop] === arr2obj[prop];
          });

          arr1obj ? __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.extend(arr1obj, arr2obj) : _seven.push(arr2obj);
        });
      }
      mergeByProperty(_seven, _reports, 'date');
      function convertSecToMin(time) {
        time = time + '000';
        time = Number(time);
        time = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(time).humanize();
        return time;
      }

      var timeresult = _seven.map(function (a) {
        a.time = a.time + "000";
        a.time = Number(a.time);
        a.time = Math.round(__WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(a.time).asMinutes());
        return a.time;
      });
      var dateresult = _seven.map(function (a) {
        a.date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(a.date).format('MMMM Do');
        return a.date;
      });

      next(function (vm) {
        vm.cdays = dateresult.reverse();
        vm.ctimes = timeresult.reverse();
        __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].commit('_charttimes', timeresult);
        __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].commit('_chartdays', dateresult);
        vm.seventime = secondsToHumanize(_totaltime);
      });
    }).catch(function (error) {
      next(false);
    });
  },

  watch: {
    $route: function $route() {
      function getSeven() {
        var _sevendays = 7;
        var _date = new Date();
        var _last = new Date(_date.getTime() - _sevendays * 24 * 60 * 60 * 1000);
        var _day = _last.getDate();
        _day = (_day < 10 ? "0" : "") + _day;
        var _month = _last.getMonth() + 1;
        _month = (_month < 10 ? "0" : "") + _month;
        var _year = _last.getFullYear();

        var _thadate = _year + '-' + _month + '-' + _day;
        return _thadate + " 00:00:00";
      }
      function secondsToHours(time) {
        time = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(time).asHours();
        return time;
      }
      function secondsToHumanize(time) {
        time = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(time, "seconds").humanize();
        return time;
      }
      var sevendays = getSeven();
      var today = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("Y-MM-D") + " 23:59:59";

      var self = this;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.kuzcoapp.com/api/v1/report?start=' + sevendays + '&end=' + today).then(function (response) {
        var _totaltime = response.data.data.total_time;
        var _reports = response.data.data.reports;
        var momentSeven = function momentSeven() {
          var arr = [];
          var _today = {
            date: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD'),
            time: "0"
          };
          arr.push(_today);
          for (var i = 1; i < 7; i += 1) {
            var ym = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(i, 'days').format('YYYY-MM-DD');
            var rm = __WEBPACK_IMPORTED_MODULE_3_moment___default()(ym).format('MMMM Do');
            var dm = {
              date: ym,
              time: "0"
            };
            arr.push(dm);
          }
          return arr;
        };
        var _seven = momentSeven();

        function mergeByProperty(_seven, _reports, prop) {
          __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.each(_reports, function (arr2obj) {
            var arr1obj = __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.find(_seven, function (arr1obj) {
              return arr1obj[prop] === arr2obj[prop];
            });

            arr1obj ? __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.extend(arr1obj, arr2obj) : _seven.push(arr2obj);
          });
        }
        mergeByProperty(_seven, _reports, 'date');

        var timeresult = _seven.map(function (a) {
          a.time = a.time + "000";
          a.time = Number(a.time);
          a.time = Math.round(__WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(a.time).asMinutes());
          return a.time;
        });
        var dateresult = _seven.map(function (a) {
          a.date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(a.date).format('MMMM Do');
          return a.date;
        });

        self.cdays = dateresult.reverse();
        self.ctimes = timeresult.reverse();

        function convertSecToMin(time) {
          time = time + '000';
          time = Number(time);
          time = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(time).humanize();
          return time;
        }
        self.seventime = secondsToHumanize(_totaltime);

        __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].commit('_charttimes', timeresult);
        __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].commit('_chartdays', dateresult);
      }).catch(function (error) {});
    }
  },
  computed: {
    datasetsfull: function datasetsfull() {
      return {
        labels: __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.chartdays,
        datasets: [{
          label: 'Time(Hours)',
          backgroundColor: '#40cF97',
          data: __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.charttimes
        }]
      };
    },
    chartdays: function chartdays() {
      return __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.chartdays;
    },
    charttimes: function charttimes() {
      return __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.charttimes;
    }
  }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ReportsCharts__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_underscore__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Thirty',
  components: { ReportsCharts: __WEBPACK_IMPORTED_MODULE_0__components_ReportsCharts__["a" /* default */] },
  data: function data() {
    return {
      thirtytime: ''
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    function getThirty() {
      var _thirtydays = 30;
      var _date = new Date();
      var _last = new Date(_date.getTime() - _thirtydays * 24 * 60 * 60 * 1000);
      var _day = _last.getDate();
      _day = (_day < 10 ? "0" : "") + _day;
      var _month = _last.getMonth() + 1;
      _month = (_month < 10 ? "0" : "") + _month;
      var _year = _last.getFullYear();

      var _thadate = _year + '-' + _month + '-' + _day;
      return _thadate + " 00:00:00";
    }
    var thirtydays = getThirty();
    var today = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format("Y-MM-D") + " 23:59:59";
    function secondsToHumanize(time) {
      time = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(time, "seconds").humanize();
      return time;
    }
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.kuzcoapp.com/api/v1/report?start=' + thirtydays + '&end=' + today).then(function (response) {
      var _totaltime = response.data.data.total_time;
      var _reports = response.data.data.reports;
      var momentThirty = function momentThirty() {
        var arr = [];
        var _today = {
          date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
          time: "0"
        };
        arr.push(_today);
        for (var i = 1; i < 30; i += 1) {
          var ym = __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(i, 'days').format('YYYY-MM-DD');
          var rm = __WEBPACK_IMPORTED_MODULE_2_moment___default()(ym).format('MMMM Do');
          var dm = {
            date: ym,
            time: "0"
          };
          arr.push(dm);
        }
        return arr;
      };
      var _thirty = momentThirty();

      function mergeByProperty(_thirty, _reports, prop) {
        __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.each(_reports, function (arr2obj) {
          var arr1obj = __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.find(_thirty, function (arr1obj) {
            return arr1obj[prop] === arr2obj[prop];
          });

          arr1obj ? __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.extend(arr1obj, arr2obj) : _thirty.push(arr2obj);
        });
      }
      mergeByProperty(_thirty, _reports, 'date');

      var timeresult = _thirty.map(function (a) {
        a.time = a.time + "000";
        a.time = Number(a.time);
        a.time = Math.round(__WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(a.time).asMinutes());
        return a.time;
      });
      var dateresult = _thirty.map(function (a) {
        a.date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.date).format('MMMM Do');
        return a.date;
      });
      next(function (vm) {
        vm.cdays = dateresult.reverse();
        vm.ctimes = timeresult.reverse();
        __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].commit('_charttimes', timeresult);
        __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].commit('_chartdays', dateresult);
        vm.thirtytime = secondsToHumanize(_totaltime);
      });
    }).catch(function (error) {
      next(false);
    });
  },

  watch: {
    $route: function $route() {
      function getThirty() {
        var _thirtydays = 30;
        var _date = new Date();
        var _last = new Date(_date.getTime() - _thirtydays * 24 * 60 * 60 * 1000);
        var _day = _last.getDate();
        _day = (_day < 10 ? "0" : "") + _day;
        var _month = _last.getMonth() + 1;
        _month = (_month < 10 ? "0" : "") + _month;
        var _year = _last.getFullYear();

        var _thadate = _year + '-' + _month + '-' + _day;
        return _thadate + " 00:00:00";
      }
      var thirtydays = getThirty();
      var today = __WEBPACK_IMPORTED_MODULE_2_moment___default()().format("Y-MM-D") + " 23:59:59";
      var self = this;
      function secondsToHumanize(time) {
        time = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(time, "seconds").humanize();
        return time;
      }
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://api.kuzcoapp.com/api/v1/report?start=' + thirtydays + '&end=' + today).then(function (response) {
        var _totaltime = response.data.data.total_time;
        var _reports = response.data.data.reports;
        var momentThirty = function momentThirty() {
          var arr = [];
          var _today = {
            date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
            time: "0"
          };
          arr.push(_today);
          for (var i = 1; i < 30; i += 1) {
            var ym = __WEBPACK_IMPORTED_MODULE_2_moment___default()().subtract(i, 'days').format('YYYY-MM-DD');
            var rm = __WEBPACK_IMPORTED_MODULE_2_moment___default()(ym).format('MMMM Do');
            var dm = {
              date: ym,
              time: "0"
            };
            arr.push(dm);
          }
          return arr;
        };
        var _thirty = momentThirty();

        function mergeByProperty(_thirty, _reports, prop) {
          __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.each(_reports, function (arr2obj) {
            var arr1obj = __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.find(_thirty, function (arr1obj) {
              return arr1obj[prop] === arr2obj[prop];
            });

            arr1obj ? __WEBPACK_IMPORTED_MODULE_5_underscore___default.a.extend(arr1obj, arr2obj) : _thirty.push(arr2obj);
          });
        }
        mergeByProperty(_thirty, _reports, 'date');

        var timeresult = _thirty.map(function (a) {
          a.time = a.time + "000";
          a.time = Number(a.time);
          a.time = Math.round(__WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(a.time).asMinutes());
          return a.time;
        });
        var dateresult = _thirty.map(function (a) {
          a.date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.date).format('MMMM Do');
          return a.date;
        });

        self.cdays = dateresult.reverse();
        self.ctimes = timeresult.reverse();
        __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].commit('_charttimes', timeresult);
        __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].commit('_chartdays', dateresult);

        self.thirtytime = secondsToHumanize(_totaltime);
      }).catch(function (error) {});
    }
  },
  computed: {
    chartdays: function chartdays() {
      return __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.chartdays;
    },
    charttimes: function charttimes() {
      return __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.charttimes;
    },
    datasetsfull: function datasetsfull() {
      return {
        labels: __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.chartdays,
        datasets: [{
          label: 'Time(Hours)',
          backgroundColor: '#40cf97',
          data: __WEBPACK_IMPORTED_MODULE_4__store_store__["a" /* store */].state.charttimes
        }]
      };
    }
  }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__);


var reactiveProp = __WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_chartjs__["Doughnut"].extend({
  mixins: [reactiveProp],
  props: ['options'],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
}));

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chart_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_store__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_timezone__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment_timezone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment_timezone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_progressbar__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_underscore__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_notifications__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mini_toastr__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mini_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_mini_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_ua__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_ua___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_ua__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_head__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_head__);



















var options = {
  color: '#4671fb',
  failedColor: '#874b4b',
  thickness: '2px',
  transition: {
    speed: '0.5s',
    opacity: '0.6s'
  },
  autoRevert: true,
  location: 'top',
  inverse: false
};

var toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
};
__WEBPACK_IMPORTED_MODULE_14_mini_toastr___default.a.init({ types: toastTypes });
function toast(_ref) {
  var title = _ref.title,
      message = _ref.message,
      type = _ref.type,
      timeout = _ref.timeout,
      cb = _ref.cb;

  return __WEBPACK_IMPORTED_MODULE_14_mini_toastr___default.a[type](message, title, timeout, cb);
}
var toastOptions = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_notifications___default.a, toastOptions);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_progressbar___default.a, options);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_axios___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_head___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_underscore___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_ua___default.a, {
  appName: 'Worklogs',
  appVersion: '1.0.0',
  trackingId: 'UA-98907449-1',
  vueRouter: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */] });

__WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.slacktoken;
__WEBPACK_IMPORTED_MODULE_5_axios___default.a.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.data.error === 'token_invalid') {
    localStorage.clear();
    __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/');
  } else if (error.response.data.error === 'token_expired') {
    localStorage.clear();
    __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push('/');
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

var vm = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store_store__["a" /* store */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */,
/* 330 */
/***/ (function(module, exports) {

module.exports = {"version":"2017b","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5","Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/La_Paz|CMT BOST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|MMT -0330 -03 -02 -0230|3I.I 3u 30 20 2u|012121212121212121212121213232323232324242423243232323232323232323232323232323232323232|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|HMT +0630 IST|-5R.k -6u -5u|01212|-18LFR.k 1unn.k HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST CDT|-7y.k -80 -90|012121212121212121212121212121212121212121|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|+08 +09|-80 -90|010101010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|01231|-2um8n 97XR 1lTzu 2Onc0|29e5","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.E -6u -90|0121|-21Jio.E SmnS.E 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -9u -a0|0123141414141414135353|-2um8r.Q 97XV.Q 1m1zu kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJH0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","EST|EST|50|0|","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Etc/GMT+0|GMT|0|0|","Etc/GMT+1|-01|10|0|","Etc/GMT+10|-10|a0|0|","Etc/GMT+11|-11|b0|0|","Etc/GMT+12|-12|c0|0|","Etc/GMT+3|-03|30|0|","Etc/GMT+4|-04|40|0|","Etc/GMT+5|-05|50|0|","Etc/GMT+6|-06|60|0|","Etc/GMT+7|-07|70|0|","Etc/GMT+8|-08|80|0|","Etc/GMT+9|-09|90|0|","Etc/GMT-1|+01|-10|0|","Pacific/Port_Moresby|+10|-a0|0||25e4","Pacific/Pohnpei|+11|-b0|0||34e3","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0|","Etc/GMT-14|+14|-e0|0|","Etc/GMT-2|+02|-20|0|","Etc/GMT-3|+03|-30|0|","Etc/GMT-4|+04|-40|0|","Etc/GMT-5|+05|-50|0|","Etc/GMT-6|+06|-60|0|","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0|","Pacific/Palau|+09|-90|0||21e3","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0|","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 -12 +12|-b0 c0 -c0|012|-AX0 W9X0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","MST|MST|70|0|","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B8n0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4","Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B8nk|51e2","Pacific/Kosrae|+11 +12|-b0 -c0|010|-AX0 1bdz0|66e2","Pacific/Majuro|+11 +12|-b0 -c0|01|-AX0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121212121212121212121212121212121212121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|75e3","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Sao_Tome","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Khartoum|Africa/Juba","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Los_Angeles|US/Pacific-New","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/East-Saskatchewan","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT+0|Etc/GMT","Etc/GMT+0|Etc/GMT-0","Etc/GMT+0|Etc/GMT0","Etc/GMT+0|Etc/Greenwich","Etc/GMT+0|GMT","Etc/GMT+0|GMT+0","Etc/GMT+0|GMT-0","Etc/GMT+0|GMT0","Etc/GMT+0|Greenwich","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Etc/GMT-11","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Port_Moresby|Pacific/Chuuk","Pacific/Port_Moresby|Pacific/Truk","Pacific/Port_Moresby|Pacific/Yap","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"]}

/***/ }),
/* 331 */,
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 68,
	"./af.js": 68,
	"./ar": 75,
	"./ar-dz": 69,
	"./ar-dz.js": 69,
	"./ar-kw": 70,
	"./ar-kw.js": 70,
	"./ar-ly": 71,
	"./ar-ly.js": 71,
	"./ar-ma": 72,
	"./ar-ma.js": 72,
	"./ar-sa": 73,
	"./ar-sa.js": 73,
	"./ar-tn": 74,
	"./ar-tn.js": 74,
	"./ar.js": 75,
	"./az": 76,
	"./az.js": 76,
	"./be": 77,
	"./be.js": 77,
	"./bg": 78,
	"./bg.js": 78,
	"./bn": 79,
	"./bn.js": 79,
	"./bo": 80,
	"./bo.js": 80,
	"./br": 81,
	"./br.js": 81,
	"./bs": 82,
	"./bs.js": 82,
	"./ca": 83,
	"./ca.js": 83,
	"./cs": 84,
	"./cs.js": 84,
	"./cv": 85,
	"./cv.js": 85,
	"./cy": 86,
	"./cy.js": 86,
	"./da": 87,
	"./da.js": 87,
	"./de": 90,
	"./de-at": 88,
	"./de-at.js": 88,
	"./de-ch": 89,
	"./de-ch.js": 89,
	"./de.js": 90,
	"./dv": 91,
	"./dv.js": 91,
	"./el": 92,
	"./el.js": 92,
	"./en-au": 93,
	"./en-au.js": 93,
	"./en-ca": 94,
	"./en-ca.js": 94,
	"./en-gb": 95,
	"./en-gb.js": 95,
	"./en-ie": 96,
	"./en-ie.js": 96,
	"./en-nz": 97,
	"./en-nz.js": 97,
	"./eo": 98,
	"./eo.js": 98,
	"./es": 100,
	"./es-do": 99,
	"./es-do.js": 99,
	"./es.js": 100,
	"./et": 101,
	"./et.js": 101,
	"./eu": 102,
	"./eu.js": 102,
	"./fa": 103,
	"./fa.js": 103,
	"./fi": 104,
	"./fi.js": 104,
	"./fo": 105,
	"./fo.js": 105,
	"./fr": 108,
	"./fr-ca": 106,
	"./fr-ca.js": 106,
	"./fr-ch": 107,
	"./fr-ch.js": 107,
	"./fr.js": 108,
	"./fy": 109,
	"./fy.js": 109,
	"./gd": 110,
	"./gd.js": 110,
	"./gl": 111,
	"./gl.js": 111,
	"./gom-latn": 112,
	"./gom-latn.js": 112,
	"./he": 113,
	"./he.js": 113,
	"./hi": 114,
	"./hi.js": 114,
	"./hr": 115,
	"./hr.js": 115,
	"./hu": 116,
	"./hu.js": 116,
	"./hy-am": 117,
	"./hy-am.js": 117,
	"./id": 118,
	"./id.js": 118,
	"./is": 119,
	"./is.js": 119,
	"./it": 120,
	"./it.js": 120,
	"./ja": 121,
	"./ja.js": 121,
	"./jv": 122,
	"./jv.js": 122,
	"./ka": 123,
	"./ka.js": 123,
	"./kk": 124,
	"./kk.js": 124,
	"./km": 125,
	"./km.js": 125,
	"./kn": 126,
	"./kn.js": 126,
	"./ko": 127,
	"./ko.js": 127,
	"./ky": 128,
	"./ky.js": 128,
	"./lb": 129,
	"./lb.js": 129,
	"./lo": 130,
	"./lo.js": 130,
	"./lt": 131,
	"./lt.js": 131,
	"./lv": 132,
	"./lv.js": 132,
	"./me": 133,
	"./me.js": 133,
	"./mi": 134,
	"./mi.js": 134,
	"./mk": 135,
	"./mk.js": 135,
	"./ml": 136,
	"./ml.js": 136,
	"./mr": 137,
	"./mr.js": 137,
	"./ms": 139,
	"./ms-my": 138,
	"./ms-my.js": 138,
	"./ms.js": 139,
	"./my": 140,
	"./my.js": 140,
	"./nb": 141,
	"./nb.js": 141,
	"./ne": 142,
	"./ne.js": 142,
	"./nl": 144,
	"./nl-be": 143,
	"./nl-be.js": 143,
	"./nl.js": 144,
	"./nn": 145,
	"./nn.js": 145,
	"./pa-in": 146,
	"./pa-in.js": 146,
	"./pl": 147,
	"./pl.js": 147,
	"./pt": 149,
	"./pt-br": 148,
	"./pt-br.js": 148,
	"./pt.js": 149,
	"./ro": 150,
	"./ro.js": 150,
	"./ru": 151,
	"./ru.js": 151,
	"./sd": 152,
	"./sd.js": 152,
	"./se": 153,
	"./se.js": 153,
	"./si": 154,
	"./si.js": 154,
	"./sk": 155,
	"./sk.js": 155,
	"./sl": 156,
	"./sl.js": 156,
	"./sq": 157,
	"./sq.js": 157,
	"./sr": 159,
	"./sr-cyrl": 158,
	"./sr-cyrl.js": 158,
	"./sr.js": 159,
	"./ss": 160,
	"./ss.js": 160,
	"./sv": 161,
	"./sv.js": 161,
	"./sw": 162,
	"./sw.js": 162,
	"./ta": 163,
	"./ta.js": 163,
	"./te": 164,
	"./te.js": 164,
	"./tet": 165,
	"./tet.js": 165,
	"./th": 166,
	"./th.js": 166,
	"./tl-ph": 167,
	"./tl-ph.js": 167,
	"./tlh": 168,
	"./tlh.js": 168,
	"./tr": 169,
	"./tr.js": 169,
	"./tzl": 170,
	"./tzl.js": 170,
	"./tzm": 172,
	"./tzm-latn": 171,
	"./tzm-latn.js": 171,
	"./tzm.js": 172,
	"./uk": 173,
	"./uk.js": 173,
	"./ur": 174,
	"./ur.js": 174,
	"./uz": 176,
	"./uz-latn": 175,
	"./uz-latn.js": 175,
	"./uz.js": 176,
	"./vi": 177,
	"./vi.js": 177,
	"./x-pseudo": 178,
	"./x-pseudo.js": 178,
	"./yo": 179,
	"./yo.js": 179,
	"./zh-cn": 180,
	"./zh-cn.js": 180,
	"./zh-hk": 181,
	"./zh-hk.js": 181,
	"./zh-tw": 182,
	"./zh-tw.js": 182
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 332;

/***/ }),
/* 333 */,
/* 334 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 335 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 336 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Art.0b4230b.png";

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/addtoslack.4982243.svg";

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/multiline.036f627.png";

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/newactivity.0eb5857.png";

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/newreports.a3cf81f.png";

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/notification.0ea3aad.png";

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/oneline.e9af511.png";

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/signin.a7bb674.gif";

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/signinwithslack.f2d272f.svg";

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/slashcommands.21d6b10.gif";

/***/ }),
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */
/***/ (function(module, exports) {

module.exports = {"_from":"vue-chartjs@^2.4.1","_id":"vue-chartjs@2.8.7","_inBundle":false,"_integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"vue-chartjs@^2.4.1","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"^2.4.1","saveSpec":null,"fetchSpec":"^2.4.1"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_shasum":"bcd1cda1a1ef8ed80581638a02cf88182d437d09","_spec":"vue-chartjs@^2.4.1","_where":"/var/www/kuzco-fe","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"bundleDependencies":false,"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"deprecated":false,"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.7"}

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(325)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(389),
  /* scopeId */
  "data-v-86728f68",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(314)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(378),
  /* scopeId */
  "data-v-0eea033c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(327)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(391),
  /* scopeId */
  "data-v-ae230484",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(317)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(381),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(313)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(377),
  /* scopeId */
  "data-v-024ff7a6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(320)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(384),
  /* scopeId */
  "data-v-4e072c9c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(321)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(385),
  /* scopeId */
  "data-v-50148212",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(323)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(219),
  /* template */
  __webpack_require__(387),
  /* scopeId */
  "data-v-7b8ad760",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(324)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(220),
  /* template */
  __webpack_require__(388),
  /* scopeId */
  "data-v-812c0ec2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(322)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(221),
  /* template */
  __webpack_require__(386),
  /* scopeId */
  "data-v-7ae623c4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(316)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(380),
  /* scopeId */
  "data-v-1124fb2e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(326)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(223),
  /* template */
  __webpack_require__(390),
  /* scopeId */
  "data-v-95bafb2a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(318)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(224),
  /* template */
  __webpack_require__(382),
  /* scopeId */
  "data-v-273386f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(319)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(225),
  /* template */
  __webpack_require__(383),
  /* scopeId */
  "data-v-3cf269e6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(315)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(226),
  /* template */
  __webpack_require__(379),
  /* scopeId */
  "data-v-0f3a94d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(312)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(376),
  /* scopeId */
  "data-v-00adc02f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("You logged "), _c('span', [_vm._v(_vm._s(_vm.thirtytime))]), _vm._v(" in the last "), _c('router-link', {
    staticClass: "reports-btn",
    attrs: {
      "to": "/reports/seven"
    }
  }, [_vm._v("7 days")]), _vm._v(" "), _c('router-link', {
    staticClass: "reports-btn",
    attrs: {
      "to": "/reports/fourteen"
    }
  }, [_vm._v("14 days")]), _vm._v(" "), _c('router-link', {
    staticClass: "reports-btn",
    attrs: {
      "to": "/reports/thirty"
    }
  }, [_vm._v("30 days")])], 1), _vm._v(" "), _c('reports-charts', {
    attrs: {
      "chart-data": _vm.datasetsfull,
      "height": 300,
      "options": {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "main-content--body"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "main-content--panel"
  }, [_c('div', {
    staticClass: "panel--top"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "panel--bottom"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "activity-content m-t-md"
  }, [(_vm.activity) ? _c('div', [_c('table', [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.computedActivities), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("capitalize")(item.duration)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("capitalize")(item.reason)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.date))])])
  }))]), _vm._v(" "), _c('router-link', {
    staticClass: "m-t-md button is-large is-primary is-outlined",
    attrs: {
      "to": "/activity"
    }
  }, [_vm._v("\n                View More\n              ")])], 1) : _c('div', [_c('h3', [_vm._v("Looks like you've never signed in to your team before.")]), _vm._v(" "), _c('h3', [_vm._v("Let's change that by signing in with the button above")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-content--header"
  }, [_c('h4', [_vm._v("Dashboard")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "activity-header m-t-md"
  }, [_c('h4', {
    staticClass: "has-text-centered"
  }, [_vm._v("Latest Activity")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Duration")]), _vm._v(" "), _c('th', [_vm._v("Reason")]), _vm._v(" "), _c('th', [_vm._v("Date and Time")])])])
}]}

/***/ }),
/* 378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "main-content--header"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column left"
  }, [_c('router-link', {
    staticClass: "router-link-active",
    attrs: {
      "to": "/admin"
    }
  }, [_c('h4', [_vm._v("Admin Reports")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column right"
  }, [_c('router-link', {
    staticClass: "router-link-active",
    attrs: {
      "to": "/admin/settings"
    }
  }, [_vm._v("\n          Go to Admin Settings\n        ")])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "main-content--body"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "main-content--panel"
  }, [_c('div', {
    staticClass: "panel--top"
  }, [_c('h3', [_vm._v("Worklogs Users")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading-icon"
  }, [_c('span', {
    staticClass: "slack-loader"
  })]) : _vm._e(), _vm._v(" "), (_vm.users) ? _c('div', {
    staticClass: "users--table"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "button is-primary is-medium kuzco-green",
      attrs: {
        "to": {
          name: 'User',
          params: {
            id: item.id
          }
        }
      }
    }, [_vm._v("View")])], 1)])
  }))])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Date Joined")]), _vm._v(" "), _c('th', [_vm._v("Reports")])])])
}]}

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("You logged "), _c('span', [_vm._v(_vm._s(_vm.seventime))]), _vm._v(" in the last "), _c('router-link', {
    staticClass: "reports-btn",
    attrs: {
      "to": "/reports/seven"
    }
  }, [_vm._v("7 days")]), _vm._v(" "), _c('router-link', {
    staticClass: "reports-btn",
    attrs: {
      "to": "/reports/fourteen"
    }
  }, [_vm._v("14 days")]), _vm._v(" "), _c('router-link', {
    staticClass: "reports-btn",
    attrs: {
      "to": "/reports/thirty"
    }
  }, [_vm._v("30 days")])], 1), _vm._v(" "), _c('reports-charts', {
    attrs: {
      "chart-data": _vm.datasetsfull,
      "height": 300
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "auth--background"
  }, [_c('div', {
    staticClass: "auth--inner"
  }, [(!_vm.added) ? [_c('h3', [_vm._v("Adding your team to Worklogs")]), _vm._v(" "), _c('div', {
    staticClass: "slack-loader"
  })] : [_c('h3', [_vm._v("Your team has been added")]), _vm._v(" "), _c('a', {
    staticClass: "kuzco-green button is-primary",
    attrs: {
      "href": "https://slack.com/oauth/authorize?scope=identity.email,identity.basic,identity.team&client_id=144664336758.147194983298&redirect_uri=https%3A%2F%2Fworklogs.co%2F%23%2Fslackauth&state=2a745b37"
    }
  }, [_vm._v("Sign in with Slack")])]], 2)])
},staticRenderFns: []}

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "dashboard"
  }, [_c('aside', {
    staticClass: "sidebar",
    class: {
      'sidebar-visible': _vm.isActive
    }
  }, [_c('div', [_c('div', {
    staticClass: "sidebar--header"
  }, [_c('a', [_vm._v(_vm._s(_vm.team))])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar--links"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/activity"
    }
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v("Activity")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/reports"
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v("Reports")])], 1), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/admin"
    }
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  }), _vm._v("Admin")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  }), _vm._v("Settings")])], 1)])])])]), _vm._v(" "), _c('section', {
    staticClass: "main-content",
    class: {
      'push-content': _vm.isActive
    }
  }, [_c('header', [_c('nav', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-half-mobile"
  }, [_c('div', {
    staticClass: "header--left"
  }, [_c('button', {
    staticClass: "hamburger hamburger--slider dashboard-hamburger",
    class: {
      'is-active': _vm.isActive
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showMenu
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('a', [_vm._v("Worklogs")]), _vm._v(" "), _c('div', {
    staticClass: "headway-app"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half-mobile"
  }, [_c('div', {
    staticClass: "header--right"
  }, [_c('div', {
    staticClass: "cog"
  }, [_c('p', [_c('a', {
    on: {
      "click": function($event) {
        _vm.signOut()
      }
    }
  }, [_vm._v("Logout")])])]), _vm._v(" "), _c('div', {
    staticClass: "username"
  }, [_c('p', [_vm._v(_vm._s(_vm.username))])])])])])])]), _vm._v(" "), _c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "hamburger-box"
  }, [_c('span', {
    staticClass: "hamburger-inner"
  })])
}]}

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('header', {
    staticClass: "main-content--header"
  }, [_c('div', {
    staticClass: "columns"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column right"
  }, [_c('router-link', {
    attrs: {
      "to": "/admin"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Back\n        ")])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "main-content--body"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "main-content--panel"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading-icon"
  }, [_c('span', {
    staticClass: "slack-loader"
  })]) : _vm._e(), _vm._v(" "), (_vm.reports) ? _c('div', {
    staticClass: "panel--top"
  }, [_c('h3', [_vm._v(_vm._s(_vm.name) + "'s Sign Ins - "), _c('span', [_vm._v(_vm._s(_vm.totaltime))])]), _vm._v(" "), _c('div', {
    staticClass: "users--table"
  }, [_c('table', [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.reports), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.date))])])
  }))])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column left"
  }, [_c('h4', [_vm._v("Admin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Duration")]), _vm._v(" "), _c('th', [_vm._v("Date")])])])
}]}

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("You logged "), _c('span', [_vm._v(_vm._s(_vm.fourteentime))]), _vm._v(" in the last "), _c('router-link', {
    staticClass: "reports-btn",
    attrs: {
      "to": "/reports/seven"
    }
  }, [_vm._v("7 days")]), _vm._v(" "), _c('router-link', {
    staticClass: "reports-btn",
    attrs: {
      "to": "/reports/fourteen"
    }
  }, [_vm._v("14 days")]), _vm._v(" "), _c('router-link', {
    staticClass: "reports-btn",
    attrs: {
      "to": "/reports/thirty"
    }
  }, [_vm._v("30 days")])], 1), _vm._v(" "), _c('reports-charts', {
    attrs: {
      "chart-data": _vm.datasetsfull,
      "height": 300,
      "options": {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('header', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "nav-right nav-menu is-active header--right"
  }, [(_vm.kuzcosignedin) ? _c('div', [_c('router-link', {
    staticClass: "nav-item dashboard-button",
    attrs: {
      "to": "/dashboard"
    }
  }, [_vm._v("Go to Dashboard")]), _vm._v(" "), _c('a', {
    staticClass: "nav-item dashboard-button",
    on: {
      "click": _vm.signOut
    }
  }, [_vm._v("Sign out")])], 1) : _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "https://slack.com/oauth/authorize?scope=identity.email,identity.basic,identity.team&client_id=144664336758.147194983298&redirect_uri=https%3A%2F%2Fworklogs.co%2Fslackauth&state=2a745b37"
    }
  }, [_c('img', {
    staticClass: "signintoslack-btn",
    attrs: {
      "src": __webpack_require__(345)
    }
  })])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-left header--left"
  }, [_c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Worklogs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "banner container-fluid"
  }, [_c('div', {
    staticClass: "banner--content"
  }, [_c('h2', {
    staticClass: "m-b-md h2"
  }, [_vm._v("Remote time tracking made convenient.")]), _vm._v(" "), _c('h4', {
    staticClass: "m-b-lg h4"
  }, [_vm._v("Worklogs is an app that allows you to track the number of working hours for remote teams right in Slack.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://slack.com/oauth/authorize?scope=incoming-webhook,commands,users:read,users.profile:write,chat:write:bot&client_id=144664336758.147194983298&redirect_uri=https%3A%2F%2Fworklogs.co%2Fslackadd&state=2a745b37"
    }
  }, [_c('img', {
    staticClass: "addtoslack-btn",
    attrs: {
      "src": __webpack_require__(338)
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "intro--top"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(337)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "intro--bottom"
  }, [_c('p', {
    staticClass: "p"
  }, [_vm._v("Worklogs is a bullshit-free time tracking app that works with your team’s Slack HQ.")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("It enables you to notify your team members when you’re available to work and what you’re working on.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "get-started"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "gs--top"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Get started in three simple steps")])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-desktop gs--bottom"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "gs-one"
  }, [_c('div', {
    staticClass: "gs-one-icon"
  }, [_c('img', {
    staticClass: "image gs-image",
    attrs: {
      "src": __webpack_require__(334)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gs-one-text"
  }, [_c('p', [_vm._v("Owner/Admin of Slack Team creates a channel dedicated for Worklogs and adds Worklogs to their Slack.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "gs-two"
  }, [_c('div', {
    staticClass: "gs-two-icon"
  }, [_c('img', {
    staticClass: "image gs-image",
    attrs: {
      "src": __webpack_require__(335)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gs-two-text"
  }, [_c('p', [_vm._v("Members of Slack Team sign in to Worklogs.co to access Dashboard.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "gs-three"
  }, [_c('div', {
    staticClass: "gs-three-icon"
  }, [_c('img', {
    staticClass: "image gs-image",
    attrs: {
      "src": __webpack_require__(336)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gs-three-text"
  }, [_c('p', [_vm._v("Members can sign in and sign out to indicate working hours.")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "features",
    attrs: {
      "id": "features"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "features--top"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Features")])]), _vm._v(" "), _c('div', {
    staticClass: "features--middle"
  }, [_c('div', {
    staticClass: "easy-signin columns"
  }, [_c('div', {
    staticClass: "column left"
  }, [_c('div', {
    staticClass: "signin-text"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('h4', [_vm._v("One Click Sign In")]), _vm._v(" "), _c('p', [_vm._v("One click sign in means you can get to work immediately. Add a reason for signing or be lazy and choose from past reasons.😎")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column right"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": __webpack_require__(344)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "k-notification columns"
  }, [_c('div', {
    staticClass: "column right is-hidden-desktop"
  }, [_c('div', {
    staticClass: "notification-text"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('h4', [_vm._v("Notifications")]), _vm._v(" "), _c('p', [_vm._v("Automatically mention someone whenever you sign in. Tell your team lead/members you're working in a passive aggressive manner. 😏")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column left"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": __webpack_require__(342)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column right is-hidden-mobile"
  }, [_c('div', {
    staticClass: "notification-text"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('h4', [_vm._v("Notifications")]), _vm._v(" "), _c('p', [_vm._v("Automatically mention someone whenever you sign in. Tell your team lead/members you're working in a passive aggressive manner. 😏")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "activity columns"
  }, [_c('div', {
    staticClass: "column left"
  }, [_c('div', {
    staticClass: "activity-text"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('h4', [_vm._v("Your Activity")]), _vm._v(" "), _c('p', [_vm._v("Detailed summary on time signed in and out with reasons and filterable date by time period.🤘🏿")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column right"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": __webpack_require__(340)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "k-notification columns"
  }, [_c('div', {
    staticClass: "column right is-hidden-desktop"
  }, [_c('div', {
    staticClass: "notification-text"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('h4', [_vm._v("Your Reports")]), _vm._v(" "), _c('p', [_vm._v("Browse through your sign ins to determine how much time you’ve logged in to work and what you worked on.📈")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column left"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": __webpack_require__(341)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column right is-hidden-mobile"
  }, [_c('div', {
    staticClass: "notification-text"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('h4', [_vm._v("Your Reports")]), _vm._v(" "), _c('p', [_vm._v("Browse through your sign ins to determine how much time you’ve logged in to work and what you worked on.📈")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "activity columns"
  }, [_c('div', {
    staticClass: "column left"
  }, [_c('div', {
    staticClass: "activity-text"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('h4', [_vm._v("New: Slash Commands")]), _vm._v(" "), _c('p', [_vm._v("Sign in and sign out can be done right in the Slack app like this "), _c('code', [_vm._v("/worklogs sign in [with optional reason] [or sign out] [or status]")]), _vm._v(". Now, you can decide to only use the Worklogs web app when you need to see reports.🔥")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column right slash"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": __webpack_require__(346)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cta columns"
  }, [_c('div', {
    staticClass: "cta-button"
  }, [_c('a', {
    attrs: {
      "href": "http://slack.com/oauth/authorize?scope=incoming-webhook,commands,users:read,chat:write:bot&client_id=144664336758.147194983298&redirect_uri=https%3A%2F%2Fworklogs.co%2F%23%2Fslackadd&state=2a745b37"
    }
  }, [_vm._v("Add Worklogs to your Slack!✌🏿")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-tablet"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("Worklogs. Copyright 2017.")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "madeby"
  }, [_vm._v("Made by "), _c('a', {
    attrs: {
      "href": "https://twitter.com/olayinkaos"
    }
  }, [_vm._v("Olayinka Omole")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://twitter.com/yomieluwande"
    }
  }, [_vm._v("Yomi Eluwande")])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-tablet"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "follow"
  }, [_c('a', {
    staticClass: "twitter-follow-button",
    attrs: {
      "href": "https://twitter.com/useworklogs",
      "data-size": "large"
    }
  }, [_vm._v("\n              Follow @Useworklogs")])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "share"
  }, [_c('p', {
    staticClass: "m-t-xs m-r-sm"
  }, [_vm._v("Share on ")]), _vm._v(" "), _c('a', {
    staticClass: "twitter-share-button m-r-md",
    attrs: {
      "target": "_blank",
      "data-size": "large",
      "href": "https://twitter.com/intent/tweet?text=Check%20out%20Worklogs.%20A%20tool%20that%20helps%20track%20working%20hours%20for%20members%20in%20remote%20teams.&url=https://worklogs.co&via=useworklogs"
    }
  }, [_vm._v("Twitter")]), _vm._v(" "), _c('div', {
    staticClass: "fb-share-button",
    attrs: {
      "data-href": "https://worklogs.co",
      "data-layout": "button_count",
      "data-size": "large",
      "data-mobile-iframe": "true"
    }
  }, [_c('a', {
    staticClass: "fb-xfbml-parse-ignore",
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fworklogs.co%2F&src=sdkpreparse"
    }
  }, [_vm._v("Share")])])])])])])])
}]}

/***/ }),
/* 385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "main-content--body"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "main-content--panel"
  }, [_c('div', {
    staticClass: "panel--top"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "panel--bottom"
  }, [_c('h3', [_vm._v("Today - "), _c('span', [_vm._v(_vm._s(_vm.todaytime))])]), _vm._v(" "), _c('today-chart', {
    attrs: {
      "chart-data": _vm.datasetsfull,
      "height": 280,
      "options": {
        responsive: false,
        maintainAspectRatio: false
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "users--table"
  }, [_c('p', {
    staticClass: "text-left m-b-md"
  }, [_vm._v("Your daily reports")]), _vm._v(" "), _c('table', [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.summaryreports), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.date))])])
  }))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-content--header"
  }, [_c('h4', [_vm._v("Reports")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Duration")]), _vm._v(" "), _c('th', [_vm._v("Date")])])])
}]}

/***/ }),
/* 386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "signedin-label"
  }, [_vm._v("Signed In")]), _vm._v(" "), _c('p', {
    staticClass: "time m-t-md"
  }, [_vm._v("Signed In: " + _vm._s(_vm.klogdate) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "reason m-b-md m-t-md"
  }, [_vm._v(_vm._s(_vm.klogreason))]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signOutSlack($event)
      }
    }
  }, [(_vm.typedreason) ? _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loggedOutReason),
      expression: "loggedOutReason"
    }],
    staticClass: "input form-control m-b-sm",
    attrs: {
      "type": "text",
      "placeholder": "Add a reason"
    },
    domProps: {
      "value": (_vm.loggedOutReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loggedOutReason = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "centered text-sm text-u-l",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.existingReason($event)
      }
    }
  }, [_vm._v("Use an existing reason?")])]) : _vm._e(), _vm._v(" "), (_vm.existing) ? _c('p', {
    staticClass: "control"
  }, [_c('v-select', {
    staticClass: "m-b-sm",
    attrs: {
      "value": _vm.loggedOutReason,
      "options": _vm.existingReasons
    },
    on: {
      "update:value": function($event) {
        _vm.loggedOutReason = $event
      }
    },
    model: {
      value: (_vm.loggedOutReason),
      callback: function($$v) {
        _vm.loggedOutReason = $$v
      },
      expression: "loggedOutReason"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "centered text-sm text-u-l",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.typedReason($event)
      }
    }
  }, [_vm._v("Type in a new reason?")])], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button is-primary is-large centered kuzco-green",
    class: {
      'is-disabled': _vm.disabled
    }
  }, [_vm._v("Sign Out\n      "), _c('span', {
    class: {
      'slack-loader': _vm.loading
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "main-content--body"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "main-content--panel"
  }, [_c('div', {
    staticClass: "panel--top"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel--bottom"
  }, [_c('h3', {
    staticClass: "text-left text-md m-t-md"
  }, [_vm._v("Tag Teammates")]), _vm._v(" "), _c('p', {
    staticClass: "text-left text-sm m-t-sm"
  }, [_vm._v("Type in the usernames (comma separated) of team members you want to be notified whenever you sign in and sign out.")]), _vm._v(" "), _c('form', {
    staticClass: "m-t-md"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label m-t-xs"
  }, [_vm._v("Teammates")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tagged),
      expression: "tagged"
    }],
    staticClass: "input form-control",
    attrs: {
      "placeholder": "Slack usernames: e.g. Jane, Joe, Jim",
      "type": "text"
    },
    domProps: {
      "value": (_vm.tagged)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tagged = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('h3', {
    staticClass: "text-left text-md m-t-md"
  }, [_vm._v("Change Timezone")]), _vm._v(" "), _c('p', {
    staticClass: "text-left text-sm m-t-sm"
  }, [_vm._v("Select your timezone so all dates and time on Worklogs are in your timezone.")]), _vm._v(" "), _c('form', {
    staticClass: "m-t-md"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label m-t-xs"
  }, [_vm._v("Timezone")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timezone),
      expression: "timezone"
    }],
    staticClass: "input form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timezone = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Pacific/Midway"
    }
  }, [_vm._v("(UTC-11:00) Midway Island")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Samoa"
    }
  }, [_vm._v("(UTC-11:00) Samoa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Honolulu"
    }
  }, [_vm._v("(UTC-10:00) Hawaii")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US/Alaska"
    }
  }, [_vm._v("(UTC-09:00) Alaska")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Los_Angeles"
    }
  }, [_vm._v("(UTC-08:00) Pacific Time (US & Canada)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Tijuana"
    }
  }, [_vm._v("(UTC-08:00) Tijuana")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US/Arizona"
    }
  }, [_vm._v("(UTC-07:00) Arizona")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Chihuahua"
    }
  }, [_vm._v("(UTC-07:00) Chihuahua")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Chihuahua"
    }
  }, [_vm._v("(UTC-07:00) La Paz")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Mazatlan"
    }
  }, [_vm._v("(UTC-07:00) Mazatlan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US/Mountain"
    }
  }, [_vm._v("(UTC-07:00) Mountain Time (US & Canada)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Managua"
    }
  }, [_vm._v("(UTC-06:00) Central America")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US/Central"
    }
  }, [_vm._v("(UTC-06:00) Central Time (US & Canada)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Mexico_City"
    }
  }, [_vm._v("(UTC-06:00) Guadalajara")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Mexico_City"
    }
  }, [_vm._v("(UTC-06:00) Mexico City")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Monterrey"
    }
  }, [_vm._v("(UTC-06:00) Monterrey")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Canada/Saskatchewan"
    }
  }, [_vm._v("(UTC-06:00) Saskatchewan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Bogota"
    }
  }, [_vm._v("(UTC-05:00) Bogota")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US/Eastern"
    }
  }, [_vm._v("(UTC-05:00) Eastern Time (US & Canada)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US/East-Indiana"
    }
  }, [_vm._v("(UTC-05:00) Indiana (East)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Lima"
    }
  }, [_vm._v("(UTC-05:00) Lima")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Bogota"
    }
  }, [_vm._v("(UTC-05:00) Quito")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Canada/Atlantic"
    }
  }, [_vm._v("(UTC-04:00) Atlantic Time (Canada)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Caracas"
    }
  }, [_vm._v("(UTC-04:30) Caracas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/La_Paz"
    }
  }, [_vm._v("(UTC-04:00) La Paz")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Santiago"
    }
  }, [_vm._v("(UTC-04:00) Santiago")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Canada/Newfoundland"
    }
  }, [_vm._v("(UTC-03:30) Newfoundland")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Sao_Paulo"
    }
  }, [_vm._v("(UTC-03:00) Brasilia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Argentina/Buenos_Aires"
    }
  }, [_vm._v("(UTC-03:00) Buenos Aires")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Argentina/Buenos_Aires"
    }
  }, [_vm._v("(UTC-03:00) Georgetown")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Godthab"
    }
  }, [_vm._v("(UTC-03:00) Greenland")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "America/Noronha"
    }
  }, [_vm._v("(UTC-02:00) Mid-Atlantic")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Atlantic/Azores"
    }
  }, [_vm._v("(UTC-01:00) Azores")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Atlantic/Cape_Verde"
    }
  }, [_vm._v("(UTC-01:00) Cape Verde Is.")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Africa/Casablanca"
    }
  }, [_vm._v("(UTC+00:00) Casablanca")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/London"
    }
  }, [_vm._v("(UTC+00:00) Edinburgh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Etc/Greenwich"
    }
  }, [_vm._v("(UTC+00:00) Greenwich Mean Time : Dublin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Lisbon"
    }
  }, [_vm._v("(UTC+00:00) Lisbon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/London"
    }
  }, [_vm._v("(UTC+00:00) London")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Africa/Monrovia"
    }
  }, [_vm._v("(UTC+00:00) Monrovia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UTC"
    }
  }, [_vm._v("(UTC+00:00) UTC")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Amsterdam"
    }
  }, [_vm._v("(UTC+01:00) Amsterdam")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Belgrade"
    }
  }, [_vm._v("(UTC+01:00) Belgrade")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Berlin"
    }
  }, [_vm._v("(UTC+01:00) Berlin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Berlin"
    }
  }, [_vm._v("(UTC+01:00) Bern")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Bratislava"
    }
  }, [_vm._v("(UTC+01:00) Bratislava")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Brussels"
    }
  }, [_vm._v("(UTC+01:00) Brussels")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Budapest"
    }
  }, [_vm._v("(UTC+01:00) Budapest")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Copenhagen"
    }
  }, [_vm._v("(UTC+01:00) Copenhagen")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Ljubljana"
    }
  }, [_vm._v("(UTC+01:00) Ljubljana")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Madrid"
    }
  }, [_vm._v("(UTC+01:00) Madrid")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Paris"
    }
  }, [_vm._v("(UTC+01:00) Paris")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Prague"
    }
  }, [_vm._v("(UTC+01:00) Prague")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Rome"
    }
  }, [_vm._v("(UTC+01:00) Rome")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Sarajevo"
    }
  }, [_vm._v("(UTC+01:00) Sarajevo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Skopje"
    }
  }, [_vm._v("(UTC+01:00) Skopje")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Stockholm"
    }
  }, [_vm._v("(UTC+01:00) Stockholm")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Vienna"
    }
  }, [_vm._v("(UTC+01:00) Vienna")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Warsaw"
    }
  }, [_vm._v("(UTC+01:00) Warsaw")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Africa/Lagos"
    }
  }, [_vm._v("(UTC+01:00) West Central Africa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Zagreb"
    }
  }, [_vm._v("(UTC+01:00) Zagreb")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Athens"
    }
  }, [_vm._v("(UTC+02:00) Athens")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Bucharest"
    }
  }, [_vm._v("(UTC+02:00) Bucharest")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Africa/Cairo"
    }
  }, [_vm._v("(UTC+02:00) Cairo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Africa/Harare"
    }
  }, [_vm._v("(UTC+02:00) Harare")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Helsinki"
    }
  }, [_vm._v("(UTC+02:00) Helsinki")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Istanbul"
    }
  }, [_vm._v("(UTC+02:00) Istanbul")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Jerusalem"
    }
  }, [_vm._v("(UTC+02:00) Jerusalem")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Helsinki"
    }
  }, [_vm._v("(UTC+02:00) Kyiv")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Africa/Johannesburg"
    }
  }, [_vm._v("(UTC+02:00) Pretoria")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Riga"
    }
  }, [_vm._v("(UTC+02:00) Riga")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Sofia"
    }
  }, [_vm._v("(UTC+02:00) Sofia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Tallinn"
    }
  }, [_vm._v("(UTC+02:00) Tallinn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Vilnius"
    }
  }, [_vm._v("(UTC+02:00) Vilnius")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Baghdad"
    }
  }, [_vm._v("(UTC+03:00) Baghdad")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Kuwait"
    }
  }, [_vm._v("(UTC+03:00) Kuwait")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Minsk"
    }
  }, [_vm._v("(UTC+03:00) Minsk")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Africa/Nairobi"
    }
  }, [_vm._v("(UTC+03:00) Nairobi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Riyadh"
    }
  }, [_vm._v("(UTC+03:00) Riyadh")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Volgograd"
    }
  }, [_vm._v("(UTC+03:00) Volgograd")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Tehran"
    }
  }, [_vm._v("(UTC+03:30) Tehran")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Muscat"
    }
  }, [_vm._v("(UTC+04:00) Abu Dhabi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Baku"
    }
  }, [_vm._v("(UTC+04:00) Baku")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Moscow"
    }
  }, [_vm._v("(UTC+04:00) Moscow")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Muscat"
    }
  }, [_vm._v("(UTC+04:00) Muscat")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Europe/Moscow"
    }
  }, [_vm._v("(UTC+04:00) St. Petersburg")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Tbilisi"
    }
  }, [_vm._v("(UTC+04:00) Tbilisi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Yerevan"
    }
  }, [_vm._v("(UTC+04:00) Yerevan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Kabul"
    }
  }, [_vm._v("(UTC+04:30) Kabul")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Karachi"
    }
  }, [_vm._v("(UTC+05:00) Islamabad")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Karachi"
    }
  }, [_vm._v("(UTC+05:00) Karachi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Tashkent"
    }
  }, [_vm._v("(UTC+05:00) Tashkent")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Calcutta"
    }
  }, [_vm._v("(UTC+05:30) Chennai")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Kolkata"
    }
  }, [_vm._v("(UTC+05:30) Kolkata")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Calcutta"
    }
  }, [_vm._v("(UTC+05:30) Mumbai")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Calcutta"
    }
  }, [_vm._v("(UTC+05:30) New Delhi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Calcutta"
    }
  }, [_vm._v("(UTC+05:30) Sri Jayawardenepura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Katmandu"
    }
  }, [_vm._v("(UTC+05:45) Kathmandu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Almaty"
    }
  }, [_vm._v("(UTC+06:00) Almaty")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Dhaka"
    }
  }, [_vm._v("(UTC+06:00) Astana")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Dhaka"
    }
  }, [_vm._v("(UTC+06:00) Dhaka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Yekaterinburg"
    }
  }, [_vm._v("(UTC+06:00) Ekaterinburg")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Rangoon"
    }
  }, [_vm._v("(UTC+06:30) Rangoon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Bangkok"
    }
  }, [_vm._v("(UTC+07:00) Bangkok")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Bangkok"
    }
  }, [_vm._v("(UTC+07:00) Hanoi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Jakarta"
    }
  }, [_vm._v("(UTC+07:00) Jakarta")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Novosibirsk"
    }
  }, [_vm._v("(UTC+07:00) Novosibirsk")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Hong_Kong"
    }
  }, [_vm._v("(UTC+08:00) Beijing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Chongqing"
    }
  }, [_vm._v("(UTC+08:00) Chongqing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Hong_Kong"
    }
  }, [_vm._v("(UTC+08:00) Hong Kong")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Krasnoyarsk"
    }
  }, [_vm._v("(UTC+08:00) Krasnoyarsk")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Kuala_Lumpur"
    }
  }, [_vm._v("(UTC+08:00) Kuala Lumpur")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australia/Perth"
    }
  }, [_vm._v("(UTC+08:00) Perth")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Singapore"
    }
  }, [_vm._v("(UTC+08:00) Singapore")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Taipei"
    }
  }, [_vm._v("(UTC+08:00) Taipei")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Ulan_Bator"
    }
  }, [_vm._v("(UTC+08:00) Ulaan Bataar")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Urumqi"
    }
  }, [_vm._v("(UTC+08:00) Urumqi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Irkutsk"
    }
  }, [_vm._v("(UTC+09:00) Irkutsk")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Tokyo"
    }
  }, [_vm._v("(UTC+09:00) Osaka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Tokyo"
    }
  }, [_vm._v("(UTC+09:00) Sapporo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Seoul"
    }
  }, [_vm._v("(UTC+09:00) Seoul")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Tokyo"
    }
  }, [_vm._v("(UTC+09:00) Tokyo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australia/Adelaide"
    }
  }, [_vm._v("(UTC+09:30) Adelaide")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australia/Darwin"
    }
  }, [_vm._v("(UTC+09:30) Darwin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australia/Brisbane"
    }
  }, [_vm._v("(UTC+10:00) Brisbane")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australia/Canberra"
    }
  }, [_vm._v("(UTC+10:00) Canberra")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Guam"
    }
  }, [_vm._v("(UTC+10:00) Guam")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australia/Hobart"
    }
  }, [_vm._v("(UTC+10:00) Hobart")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australia/Melbourne"
    }
  }, [_vm._v("(UTC+10:00) Melbourne")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Port_Moresby"
    }
  }, [_vm._v("(UTC+10:00) Port Moresby")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Australia/Sydney"
    }
  }, [_vm._v("(UTC+10:00) Sydney")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Yakutsk"
    }
  }, [_vm._v("(UTC+10:00) Yakutsk")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Vladivostok"
    }
  }, [_vm._v("(UTC+11:00) Vladivostok")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Auckland"
    }
  }, [_vm._v("(UTC+12:00) Auckland")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Fiji"
    }
  }, [_vm._v("(UTC+12:00) Fiji")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Kwajalein"
    }
  }, [_vm._v("(UTC+12:00) International Date Line West")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Kamchatka"
    }
  }, [_vm._v("(UTC+12:00) Kamchatka")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Magadan"
    }
  }, [_vm._v("(UTC+12:00) Magadan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Fiji"
    }
  }, [_vm._v("(UTC+12:00) Marshall Is.")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Magadan"
    }
  }, [_vm._v("(UTC+12:00) New Caledonia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Asia/Magadan"
    }
  }, [_vm._v("(UTC+12:00) Solomon Is.")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Auckland"
    }
  }, [_vm._v("(UTC+12:00) Wellington")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pacific/Tongatapu"
    }
  }, [_vm._v("(UTC+13:00) Nuku'alofa")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "control submit m-t-md"
  }, [_c('button', {
    staticClass: "button is-primary save-btn",
    class: {
      'is-disabled': _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Update\n                "), _c('span', {
    class: {
      'slack-loader': _vm.loading
    }
  })])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-content--header"
  }, [_c('h4', [_vm._v("Settings")])])
}]}

/***/ }),
/* 388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Hello " + _vm._s(_vm.username) + ",")]), _vm._v(" "), _c('h3', [_vm._v("Let everyone know you're online and working.")]), _vm._v(" "), _c('div', {
    staticClass: "m-t-md m-b-md"
  }, [_c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signInToSlack($event)
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Reason (Optional)")]), _vm._v(" "), (_vm.typedreason) ? _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formReason),
      expression: "formReason"
    }],
    staticClass: "input form-control m-b-sm",
    attrs: {
      "type": "text",
      "placeholder": "Add a reason"
    },
    domProps: {
      "value": (_vm.formReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formReason = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "centered text-sm text-u-l",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.existingReason($event)
      }
    }
  }, [_vm._v("Use an existing reason?")])]) : _vm._e(), _vm._v(" "), (_vm.existing) ? _c('p', {
    staticClass: "control"
  }, [_c('v-select', {
    staticClass: "m-b-sm",
    attrs: {
      "value": _vm.formReason,
      "options": _vm.existingReasons
    },
    on: {
      "update:value": function($event) {
        _vm.formReason = $event
      }
    },
    model: {
      value: (_vm.formReason),
      callback: function($$v) {
        _vm.formReason = $$v
      },
      expression: "formReason"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "centered text-sm text-u-l",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.typedReason($event)
      }
    }
  }, [_vm._v("Type in a new reason?")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-large centered kuzco-green",
    class: {
      'is-disabled': _vm.disabled
    }
  }, [_vm._v("Sign In\n            "), _c('span', {
    class: {
      'slack-loader': _vm.loading
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "main-content--body"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "main-content--panel"
  }, [(_vm.activity) ? _c('div', [_c('table', [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.activities), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("capitalize")(item.duration)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("capitalize")(item.reason)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.date))])])
  }))])]) : _c('div', [_vm._m(2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-content--header"
  }, [_c('h4', [_vm._v("Activity")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Duration")]), _vm._v(" "), _c('th', [_vm._v("Reason")]), _vm._v(" "), _c('th', [_vm._v("Date")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-activity"
  }, [_c('h2', [_vm._v("Oops!")]), _vm._v(" "), _c('h3', [_vm._v("Nothing to see here!")]), _vm._v(" "), _c('h3', [_vm._v("Looks like you've never signed in to your team before.")])])
}]}

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "auth--background"
  }, [_c('div', {
    staticClass: "auth--inner"
  }, [_c('h3', [_vm._v("Logging you in to Worklogs")]), _vm._v(" "), _c('div', {
    staticClass: "slack-loader"
  })])])
}]}

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "main-content--header"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column left"
  }, [_c('router-link', {
    staticClass: "router-link-active",
    attrs: {
      "to": "/admin/settings"
    }
  }, [_c('h4', [_vm._v("Admin Settings")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column right"
  }, [_c('router-link', {
    staticClass: "router-link-active",
    attrs: {
      "to": "/admin"
    }
  }, [_vm._v("\n          Go to Admin Reports\n        ")])], 1)])]), _vm._v(" "), _c('section', {
    staticClass: "main-content--body"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "main-content--panel"
  }, [_c('div', {
    staticClass: "panel--top"
  }, [_c('div', {
    staticClass: "m-t-lg"
  }, [_c('h3', {
    staticClass: "text-left text-md m-t-lg"
  }, [_vm._v("Message Style")]), _vm._v(" "), _c('p', {
    staticClass: "text-left text-sm m-t-sm"
  }, [_vm._v("Select how you want your Worklogs messages to display on Slack")]), _vm._v(" "), _c('form', {
    staticClass: "m-t-md",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messagetype),
      expression: "messagetype"
    }],
    attrs: {
      "type": "radio",
      "value": "2",
      "name": "question"
    },
    domProps: {
      "checked": _vm._q(_vm.messagetype, "2")
    },
    on: {
      "__c": function($event) {
        _vm.messagetype = "2"
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "src": __webpack_require__(343)
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio second-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messagetype),
      expression: "messagetype"
    }],
    attrs: {
      "type": "radio",
      "value": "1",
      "name": "question"
    },
    domProps: {
      "checked": _vm._q(_vm.messagetype, "1")
    },
    on: {
      "__c": function($event) {
        _vm.messagetype = "1"
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "src": __webpack_require__(339)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control submit m-t-md"
  }, [_c('button', {
    staticClass: "button is-primary save-btn",
    class: {
      'is-disabled': _vm.disabled
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Update\n                  "), _c('span', {
    class: {
      'sslack-loader': _vm.sloading
    }
  })])])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('vue-progress-bar')], 1)
},staticRenderFns: []}

/***/ }),
/* 393 */,
/* 394 */,
/* 395 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[229]);


// WEBPACK FOOTER //
// static/js/app.948a02e138a89b04679c.js